<style  lang="scss" scoped>
.box {
    padding-left: 20px;
}

.flex {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
}

.A1 {
    color: #1A1A1A;
}

.timeline {
    margin-top: 17px;

    .timeline-li {
        width: 100%;
        display: grid;
        grid-template-columns: 14px auto;
        grid-gap: 0 14px;
        min-height: 78px;

        &:nth-last-of-type(1) {
            .line .line-tail {
                display: none;
            }

            min-height: 20px;
        }

        .line {
            display: flex;
            // justify-content: center;
            flex-direction: column;
            align-items: center;

            .line-item {
                border-radius: 50%;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;
                border-style: solid;
                border-width: 2px;
                width: 14px;
                height: 14px;
                border-color: #B1B1B1;

                &.success {
                    border-color: #00C4A1;

                    &::after {
                        content: "";
                        top: 2px;
                        left: 2px;
                        width: 6px;
                        height: 6px;
                        background: #00C4A1;
                        border-radius: 50%;
                    }
                }

                &.danger {
                    border-color: #FF3535;
                }
            }

            .line-tail {
                flex: 1;
                z-index: 1;
                width: 2px;
                background: #B1B1B1;
                border: none;

                &.success {
                    background: #00C4A1;
                }

                &.danger {
                    background: linear-gradient(0deg, #FF3535 0%, #00C4A1 100%);
                }
            }
        }

        .content {
            padding-bottom: 20px;

            .name {
                font-size: 16px;
                font-weight: 400;
                color: #1A1A1A;
                line-height: 16px;
                margin-bottom: 5px;
            }

            .htmlStr {
                ::v-deep p {
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #1A1A1A;
                    line-height: 20px;
                }
            }

        }
    }
}
</style>
<template>
    <div class="timeline" v-if="props.list && props.list.length">
        <div class="timeline-li" v-for="(item, idx) in props.list" :key="idx">
            <div class="line">
                <div :class="`line-item ${item.type}`"></div>
                <div :class="`line-tail ${linefn(props.list, idx)}`" v-if="props.list.length > 1"></div>
            </div>
            <div class="content">
                <div class="name">{{ item.content }}</div>
                <el-progress :percentage="item.rate" v-if="item.rate != 0 && item.rate != 100" />
                <div class="htmlStr" v-if="item.htmlStr" v-html="item.htmlStr"></div>
            </div>
        </div>
    </div>
</template>
  
<script setup>
import {
    // eslint-disable-next-line no-unused-vars
    ref,
    // eslint-disable-next-line no-unused-vars
    watch,
    onBeforeMount,
    // eslint-disable-next-line no-unused-vars
    onMounted,
    reactive,
    // eslint-disable-next-line no-unused-vars
    defineExpose,
    // eslint-disable-next-line no-unused-vars
    computed,
    onBeforeUnmount,
    defineProps,
} from "vue";
// eslint-disable-next-line no-unused-vars
import { getProjectActions, getProStatus, getRateLog, submitRateValue, } from '@/api/index';
import { useStore } from "vuex";
// eslint-disable-next-line no-unused-vars
import { ElMessage, ElMessageBox } from "element-plus";
// eslint-disable-next-line no-unused-vars
const store = useStore();
const props = defineProps(['list', 'id'])
onBeforeMount(async () => {
    // getLogList();
    // getList();
});
onBeforeUnmount(() => { });
// eslint-disable-next-line no-unused-vars
const state = reactive({
})
const linefn = (arr, idx) => {
    if (idx < arr.length - 1) {
        if (arr[idx + 1].type === 'danger') {
            return 'danger'
        }
        if (arr[idx].type === 'danger') {
            return ''
        }
    } else {
        return ''
    }
}


</script>

  